import { render, staticRenderFns } from "./testimonialsCard.vue?vue&type=template&id=422faea4&scoped=true"
import script from "./testimonialsCard.vue?vue&type=script&lang=js"
export * from "./testimonialsCard.vue?vue&type=script&lang=js"
import style0 from "./testimonialsCard.vue?vue&type=style&index=0&id=422faea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422faea4",
  null
  
)

export default component.exports